export default __webpack_public_path__ + "static/media/avalanche.843a7982.png";